import { OpinionModel } from 'components/Opinion/Opinion.hooks';

export type ArticleContentProps = OpinionModel;

export const ArticleContent = ({ title, text }: ArticleContentProps) => {
  return (
    <div className="article-content">
      <h5 className="mt-3">{title}</h5>
      <p className="my-2 white-space-pre-line">{text}</p>
    </div>
  );
};
